function getEnvVar(key: string, required = true): string {
  const value = import.meta.env[key];
  
  if (required && !value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  
  return value ?? '';
}

export const env = {
  GOOGLE_CLIENT_ID: getEnvVar('VITE_GOOGLE_CLIENT_ID'),
  // Prod is served same-origin behind CloudFront (which proxies /api, /auth, /oauth2, /login
  // to the backend ALB), so default to the actual origin — NOT a hardcoded localhost. An empty
  // VITE_API_BASE is falsy, so the old `|| 'http://localhost:3000'` baked localhost into every
  // API/auth/login URL in the deployed bundle. window.location.origin is absolute, so the
  // `new URL(...)` callers (e.g. the chatbot) keep working. Dev still defaults to :3000.
  API_BASE:
    getEnvVar('VITE_API_BASE', false) ||
    (import.meta.env.PROD ? window.location.origin : 'http://localhost:3000'),
  DEV_PORT: getEnvVar('VITE_DEV_PORT', false) || '5173',
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
} as const;
